import { render } from "./real-dialog.vue?vue&type=template&id=58efec5a"
import script from "./real-dialog.vue?vue&type=script&lang=js"
export * from "./real-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__